Monitoring.Views.Dashboards ||= {}

class Monitoring.Views.Dashboards.SessionSharingView extends Backbone.View
  template: JST["backbone/templates/monitoring/dashboards/session_sharing"]

  events:
    'keyup #session-sharing-title-text': 'onChangeTitle'
    'click .copy-link-button': 'copyLink'
    'click #save': 'onClickSave'
    'click #stop-sharing': 'onClickStopSharing'

  initialize: (@options = {}) ->
    @dashboardSessionUuid = @options.uuid
    @edit = @options.edit
    @title = @options.title || ''
    @initialTitle = @title
    @url = @options.url || ''

  render: ->
    @$el.html(@template(@))
    @updateDoneButtonStatus(@title)
    @

  onClickShare: ->
    @showCreationModal()

  showCreationModal: ->
    if @edit
      @$el.find('#session-sharing-title-text').removeAttr('readonly')
      @$el.find('#session-sharing-title-text').css('cursor', 'auto')
      @$el.find('.save-button').show()
      @$el.find('.shared-session-button').hide()

    @$el.find('.session-sharing-edit').modal()
    setTimeout =>
      @$el.find('#session-sharing-title-text').focus()
    , 500

  onChangeTitle: ->
    input = @$el.find('#session-sharing-title-text')
    newValue = input.val()
    @updateDoneButtonStatus(newValue)
    @title = newValue

  updateDoneButtonStatus: (editedTitle) ->
    if @edit
      if editedTitle == @initialTitle
        @$el.find('#save').attr('disabled', true)
      else
        @$el.find('#save').removeAttr('disabled')
    else
      @$el.find('#save').removeAttr('disabled')

  copyLink: ->
    input = @$el.find('#session-sharing-url-text')[0]
    input.select()
    document.execCommand("copy")

  onClickSave: (event) ->
    @$el.find('#save').hide()
    @$el.find('#saving').show()
    if @edit
      @save()
    else
      @share()

  save: ->
    $.ajax
      type: 'POST'
      url: "/monitoring/sessions/dashboard_sessions/#{@dashboardSessionUuid}/edit_sharing"
      data:
        title: @title
      success: (response) =>
        console.log('edited shared session successfully')
        @$el.find('#save').show()
        @$el.find('#saving').hide()
        @initialTitle = @title
        @updateDoneButtonStatus(@title)
      error: (response) =>
        console.log('error sharing')
        console.log(response)
        showError I18n.t('generic_error_message')
        @$el.find('#save').show()
        @$el.find('#saving').hide()

  share: ->
    $.ajax
      type: 'POST'
      url: "/monitoring/sessions/dashboard_sessions/#{@dashboardSessionUuid}/share"
      data:
        title: @title
      success: (response) =>
        console.log('shared session successfully')
        @$el.find('#save').show()
        @$el.find('#saving').hide()
        @url = response.url
        @updateViewAfterSharing()
      error: (response) =>
        console.log('error sharing')
        console.log(response)
        showError I18n.t('generic_error_message')
        @$el.find('#save').show()
        @$el.find('#saving').hide()

  updateViewAfterSharing: ->
    @$el.find('#session-sharing-url-text').val(@url)
    @$el.find('#session-sharing-title-text').attr('placeholder', '')
    @$el.find('#session-sharing-title-text').attr('readonly', true)
    @$el.find('#session-sharing-title-text').css('cursor', 'default')
    @$el.find('.generated-url-row').show()
    @$el.find('.cancel-button').text(I18n.t('monitoring.dashboard.session_sharing.close'))
    @$el.find('.save-button').text(I18n.t('monitoring.dashboard.session_sharing.save'))
    @$el.find('.save-button').hide()
    @$el.find('.shared-session-button').show()
    @$el.find('#stop-sharing').show()
    @edit = true
    @initialTitle = @title
    @updateDoneButtonStatus(@title)
    @trigger('sharedSession:changed', {
      uuid: @dashboardSessionUuid
      edit: @edit
      title: @title
      url: @url
    })

  onClickStopSharing: ->
    swal({
      title: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_confirmation')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_yes')
      cancelButtonText: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_no')
      closeOnConfirm: true
    }, =>
      @stopSharing()
    )

  stopSharing: ->
    @$el.find('#save').hide()
    @$el.find('#saving').show()

    $.ajax
      type: 'POST'
      url: "/monitoring/sessions/dashboard_sessions/#{@dashboardSessionUuid}/stop_sharing"
      success: (response) =>
        console.log('stopped sharing session successfully')
        setTimeout =>
          @$el.find('#save').show()
          @$el.find('#saving').hide()
          @updateViewAfterStopSharing()
        , 500
        @$el.find('.session-sharing-edit').modal('hide')
      error: (response) =>
        console.log('error stopping sharing')
        console.log(response)
        showError I18n.t('generic_error_message')
        @$el.find('#save').show()
        @$el.find('#saving').hide()

  updateViewAfterStopSharing: ->
    @$el.find('.generated-url-row').hide()
    @$el.find('#session-sharing-url-text').val('')
    @$el.find('.cancel-button').text(I18n.t('monitoring.dashboard.session_sharing.cancel'))
    @$el.find('.save-button').text(I18n.t('monitoring.dashboard.session_sharing.done'))
    @$el.find('#stop-sharing').hide()
    @edit = false
    @title = ''
    @initialTitle = @title
    @$el.find('#session-sharing-title-text').val('')
    @updateDoneButtonStatus(@title)
    @url = ''
    @trigger('sharedSession:changed', {
      uuid: @dashboardSessionUuid
      edit: @edit
      title: @title
      url: @url
    })
